import { breakpoints } from '../breakpoints';
export const MobileQuery = `(max-width:${breakpoints.desktop})`;
export const MobileQuerySelector = `@media(${MobileQuery})`;
export const DesktopQuery = `(min-width:${breakpoints.desktop})`;
export const DesktopQuerySelector = `@media(${DesktopQuery})`;
